import { render } from "./AddServiceModel.vue?vue&type=template&id=e4b4f3e2&scoped=true"
import script from "./AddServiceModel.vue?vue&type=script&lang=js"
export * from "./AddServiceModel.vue?vue&type=script&lang=js"

import "./AddServiceModel.vue?vue&type=style&index=0&id=e4b4f3e2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4b4f3e2"]])

export default __exports__